export class SuperTipoEntidadDTOI{
    codigo : String;
    codsuper : String;
}